import { _ } from "libs";

import React from "react";
import { Court } from "../../../types";

const CourtItemMedium = ({
	court,
	extraClass = "",
	value = null,
}: {
	court: Court;
	extraClass?: string;
	value?: any;
}) => (
	<div className={`item court ${extraClass}`}>
		<div className="itemIcon courtIcon" data-court-sport={court.sport} data-court-surface={court.surfaceType} />
		<div className="itemBody">
			<div className="title">{court.name}</div>
			<div className="meta">
				{_("courtSport." + court.sport)} / {_("courtSurface." + court.surfaceType)} /{" "}
				{_("courtType." + court.courtType)}
			</div>
		</div>
	</div>
);

export default CourtItemMedium;
